import clientConfigurationEscl from '../locales/es-CL/clientConfigurations.json';
import clientConfigurationEsmx from '../locales/es-MX/clientConfigurations.json';
import clientConfigurationEsco from '../locales/es-CO/clientConfigurations.json';
import clientConfigurationEnus from '../locales/en-US/clientConfigurations.json';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import showConfirmation from '@waypoint/vue-confirmation';
import showAlert from '../alert/alertHandler';

export default {
  name: 'Operations',
  components: {
    Multiselect,
    BuscadorDirecciones,
    GoogleMapsApiLoader,
  },
  i18n: {
    messages: {
      'es-CL': {
        clientConfiguration: clientConfigurationEscl,
      },
      'es-MX': {
        clientConfiguration: clientConfigurationEsmx,
      },
      'es-CO': {
        clientConfiguration: clientConfigurationEsco,
      },
      'en-US': {
        clientConfiguration: clientConfigurationEnus,
      },
    },
  },
  data() {
    return {
      isPageBussy: false,
      dataAccess: null,
      timeZones: [],
      selectedTimeZone: null,
      client: {
        name: null,
        legalName: null,
        legalNumber: null,
        giro: null,
      },
      clientForm: null,
      address: {
        country: null,
        state: null,
        city: null,
        street: null,
      },
      gapi: null,
    };
  },
  async created() {
    GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.isPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.timeZones = await this.getTimeZones();
      this.client = await this.getClient();
      this.isPageBussy = false;
      console.log('data cli', this.client);
    },
    async getClient() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(
          `${this.$store.getters.urlAPI}/api/client/${this.$store.getters.clientId}`,
          config,
        );
        if (response.status === 200) {
          const client = response.data.data;
          this.$store.commit('saveClient', client);
          this.prepareClient(client);
          return client;
        }
      } catch (e) {
        return null;
      }
    },
    async getTimeZones() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/timeZone`, config);
        if (response.status === 200) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    prepareClient(client) {
      if (client.legalName === client.legalNumber && client.legalNumber === client.name) {
        client.legalName = null;
        client.legalNumber = null;
      }
      this.selectedTimeZone = this.timeZones.find((tZone) => tZone.id === client.timezone);
      this.prepareAddress(client.address);
    },
    prepareAddress(address) {
      this.address = address;
      this.address.streetNameSimple = address.street;
      this.address.country = address.country.name;
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        this.address.addressComplement = addressInfo.addressComplement;
        this.address.addressExtra = `${addressInfo.city} ${addressInfo.state}`;
        this.address.address =
          addressInfo.number !== undefined
            ? `${addressInfo.streetName} ${addressInfo.number} ${this.address.addressExtra}`
            : `${addressInfo.streetName} ${this.address.addressExtra}`;
        this.address.lat = addressInfo.coordinates.lat;
        this.address.lon = addressInfo.coordinates.lng;
        this.address.city = addressInfo.city;
        this.address.state = addressInfo.state;
        this.address.country = addressInfo.country;
        this.address.streetNameSimple =
          addressInfo.number !== undefined ? `${addressInfo.streetName} ${addressInfo.number}` : addressInfo.streetName;
      }
    },
    confirmEdit() {
      if (this.validate()) {
        this.hidePopover('streetNameSimple');
        this.hidePopover('city');
        this.hidePopover('state');
        this.hidePopover('country');
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('clientConfiguration.confirm'),
          () => {
            this.saveChanges();
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
    },
    async saveChanges() {
      this.isPageBussy = true;
      try {
        const body = {
          ...this.client,
          name: this.client.name,
          legalName: this.client.legalName,
          legalNumber: this.client.legalNumber,
          description: this.client.description,
          giro: this.client.giro,
          billingContactName: this.client.billingContactName,
          billingContactEmail: this.client.billingContactEmail,
          timezone: this.selectedTimeZone ? this.selectedTimeZone.id : 1,
          address: {
            id: this.address.id,
            lat: this.address.lat,
            lon: this.address.lon,
            street: this.address.streetNameSimple,
            addressComplement: this.address.addressComplement ? this.address.addressComplement : null,
            city: this.address.city,
            state: this.address.state,
            country: {
              name: this.address.country.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
            },
          },
        };
        delete body.id;
        const url = `${this.$store.getters.urlAPI}/api/client/${this.$store.getters.clientId}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        console.log('Datos de cliente ', body);
        const response = await axios.patch(url, body, config);
        const client = response.data.data;
        console.log('Data actualizada ', client);
        this.client = await this.getClient();
        this.isPageBussy = false;
        showAlert(this.$t('clientConfiguration.alert.title'), this.$t('clientConfiguration.alert.message'));
      } catch (e) {
        this.isPageBussy = false;
        showAlert('Error', this.$t('clientConfiguration.alert.errorMessage'));
        return null;
      }
    },
    validate() {
      const clientData = this.validateCLient();
      const clientContact = this.validateContact();
      const clientAddress = this.validateAddress();
      return clientData && clientContact && clientAddress;
    },
    validateCLient() {
      const legalName = this.validateLegalName();
      const legalNumber = this.validateLegalNumber();
      const giro = this.validateGiro();
      return legalName && legalNumber && giro;
    },
    validateLegalName() {
      if (this.client.legalName !== null && this.client.legalName !== undefined && this.client.legalName.length > 0) {
        return true;
      }
      this.showPopover('legalName');
      return false;
    },
    validateLegalNumber() {
      if (
        this.client.legalNumber !== null &&
        this.client.legalNumber !== undefined &&
        this.client.legalNumber.length > 0
      ) {
        return true;
      }
      this.showPopover('legalNumber');
      return false;
    },
    validateGiro() {
      if (this.client.giro !== null && this.client.giro !== undefined && this.client.giro.length > 0) {
        return true;
      }
      this.showPopover('giro');
      return false;
    },
    validateContact() {
      const contactName = this.validateContactName();
      const contactEmail = this.validateContactEmail();
      return contactName && contactEmail;
    },
    validateContactName() {
      if (
        this.client.billingContactName !== null &&
        this.client.billingContactName !== undefined &&
        this.client.billingContactName.length > 0
      ) {
        return true;
      }
      this.showPopover('contactName');
      return false;
    },
    validateContactEmail() {
      if (
        this.client.billingContactEmail !== null &&
        this.client.billingContactEmail !== undefined &&
        this.client.billingContactEmail.length > 0 &&
        this.isEmailValid()
      ) {
        return true;
      }
      this.showPopover('contactEmail');
      return false;
    },
    isEmailValid() {
      const re = /^[a-zA-Z0-9.ñ_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(this.client.billingContactEmail.trim());
    },
    validateAddress() {
      const street = this.validateStreet();
      const city = this.validateCity();
      const state = this.validateState();
      const country = this.validateCountry();
      return street && city && state && country;
    },
    validateStreet() {
      if (
        this.address.streetNameSimple !== null &&
        this.address.streetNameSimple !== undefined &&
        this.address.streetNameSimple.length > 0
      ) {
        return true;
      }
      this.showPopover('streetNameSimple');
      return false;
    },
    validateCity() {
      if (this.address.city !== null && this.address.city !== undefined && this.address.city.length > 0) {
        return true;
      }
      this.showPopover('city');
      return false;
    },
    validateState() {
      if (this.address.state !== null && this.address.state !== undefined && this.address.state.length > 0) {
        return true;
      }
      this.showPopover('state');
      return false;
    },
    validateCountry() {
      if (this.address.country !== null && this.address.country !== undefined && this.address.country.length > 0) {
        return true;
      }
      this.showPopover('country');
      return false;
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
  },
  computed: {},
};
